import { DateUtils } from "src/utils/date.util";
import { Timestamp } from "firebase/firestore";

export const calcPercentage = (total: number, count: number) => {
  if (total == 0 || total == 0) return 0;
  const result = (count / total) * 100;
  return result.toFixed(2);
};

export const getLastMonthTimestamp = () => {
  return Timestamp.fromDate(DateUtils.subtract(new Date(), 30, "day").toJSDate());
};

export function formatExpiryInterval(expiryHours: number): string {
  const totalMinutes = Math.round(expiryHours * 60);
  if (totalMinutes < 60) {
    return `Update every ${totalMinutes} minute${totalMinutes === 1 ? "" : "s"}`;
  }
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const hoursPart = `${hours} hour${hours === 1 ? "" : "s"}`;
  const minutesPart = minutes ? ` and ${minutes} minute${minutes === 1 ? "" : "s"}` : "";

  return `Update every ${hoursPart}${minutesPart}`;
}
